export default {
  charging_packages: {
    statuses: {
      expired: '已过期',
      available: '可使用',
      pending: '未生效'
    }
  }
}
